import { render, staticRenderFns } from "./ProjectStagesList.vue?vue&type=template&id=d387ba96&scoped=true"
import script from "./ProjectStagesList.vue?vue&type=script&lang=js"
export * from "./ProjectStagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d387ba96",
  null
  
)

export default component.exports